module.exports = __webpack_public_path__ + "static/rainbow-0086c213951436b5bece61e28900c72a.gif";